import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { CompanyUserModel } from './models/company-user.model';

/** HTTP client for the monolith company-users endpoint. */
@Injectable({ providedIn: 'root' })
export class CompanyUsersApiService {
  private readonly http = inject(HttpClient);
  private readonly monolith = inject(ENVIRONMENT).origin.monolith;

  getCompanyUsers(): Observable<CompanyUserModel[]> {
    return this.http.get<CompanyUserModel[]>(`${this.monolith}/Users?company=true`);
  }
}
